import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FooterButton } from '@rivethealth/data/buttons';
import { TreeOption } from '@rivethealth/data/options';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnalyticsEventOutput } from '../analytics/common-analytics.service';
import { Loadable } from '../helpers/loadable';
import { FiltersComponent } from './filters.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'filter-combo-tree',
  templateUrl: './filter-combo-tree.component.html',
  styleUrls: ['./filter-combo-tree.component.scss'],
})
export class FilterComboTreeComponent<Name extends string, T> {
  constructor(
    private readonly filtersComponent: FiltersComponent<{ [K in Name]: T[] }>,
  ) {}

  @Input() options: TreeOption[] = [];
  @Input() loadable?: Observable<Loadable<any[]>>;
  @Input() selectAllButton: FooterButton;
  @Input() leftButtons: FooterButton[];
  @Input() rightButtons: FooterButton[];
  @Input()
  readonly analyticsEvents: {
    clicked?: AnalyticsEventOutput<string>;
  } = {};

  @Input()
  name: Name;

  @Input()
  selectedEnabled: boolean = true;

  getAll(selected: any[] | null) {
    return selected && selected.length === 1 && selected[0] === 'all';
  }

  readonly selected = this.filtersComponent.value.pipe(
    map(value => [...value[this.name]]),
  );

  changeSelected(value: T[]) {
    this.filtersComponent.changeValue.next({
      name: this.name,
      reduce: () => [...value],
    });
  }
}
